module.exports = __webpack_public_path__ + "media/src/images/icons/flags/united_kingdom-2d0ebdf7dc78a803e92a0b6debf8bbc2.svg";